<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>   
  <h3 class="text-base mb-4">BRAND SETTINGS</h3>
  <div class="vx-row" v-if="!$store.getters['dash/isCollaborator']">
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/locations')}">
          <img src="@/assets/images/misc/locations.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Locations</h4>
          <p class="mt-1 mx-auto max-w-xs">Add or manage other locations for this brand.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {$router.push('/dash/settings/plan')}">
          <img src="@/assets/images/misc/plan.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Billing & Plan</h4>
          <p class="mt-1 mx-auto max-w-xs">Upgrade or manage your plan subscription.</p>
        </vx-card>
    </div>
  </div>

  <div>
    <h3 class="text-base mb-4">USER PROFILE</h3>
    <div class="vx-row" v-if="!$store.getters['dash/isCollaborator']">
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {$router.push('/dash/settings/myprofile')}">
          <img src="@/assets/images/misc/profile.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Profile</h4>
          <p class="mt-1 mx-auto max-w-xs">Manage your login information.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {$router.push('/dash/settings/notifications')}">
          <img src="@/assets/images/misc/notifications.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Notifications</h4>
          <p class="mt-1 mx-auto max-w-xs">Manage your notification settings.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {$router.push('/dash/settings/myprofile')}">
          <img src="@/assets/images/misc/signout.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Sign Out</h4>
          <p class="mt-1 mx-auto max-w-xs">Sign out of this session.</p>
        </vx-card>
    </div>
    </div>
  </div>

</div>
</template>


<script>

/*

<h5 class="mb-4">My Profile and Notifications</h5>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/notifications')}">
          <img src="@/assets/images/misc/notifications.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Notifications</h4>
          <p class="mt-1 mx-auto max-w-xs">Change how you receive notifications for new feedback.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {$router.push('/dash/settings/myprofile')}">
          <img src="@/assets/images/misc/profile.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">My Profile</h4>
          <p class="mt-1 mx-auto max-w-xs">Manage your profile email and password.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer " @click="() => {
          $store.dispatch('auth/logout').then(() => {
            //the main.js code will catch auth state change
          }).catch(() => {})
          }">
          <img src="@/assets/images/misc/signout.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Sign Out</h4>
          <p class="mt-1 mx-auto max-w-xs">Sign out of your current session.</p>
        </vx-card>
    </div>
  </div>


 <h5 class="mb-4">{{ 'Settings for ' + $store.state.dash.viewData.business.businessName  }}</h5>
  <div class="vx-row">
    <!-- CARD 1: CONGRATS -->
    <div class="vx-col w-full lg:w-4/12 mb-base flex" v-if="!$store.getters['dash/isCollaborator']">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/collaborators')}">
          <img src="@/assets/images/misc/collaborators.png" class="w-32 mx-auto"/>
          <h4 class="font-medium">{{ $store.getters['dash/agency'].isClientName ? 'Client Collaborators' : 'Collaborators' }}</h4>
          <p class="mt-1 mx-auto max-w-xs" v-if="$store.getters['dash/agency'].isClientName">Invite clients as collaborators to view feedback and send invites.</p>
          <p v-else class="mt-1 mx-auto max-w-xs">Invite others to view feedback and send out invites.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/businessinformation')}">
          <img src="@/assets/images/misc/businessinfo.png" class="w-32 mx-auto"/>
          <h4 class="font-medium">Business Information</h4>
          <p class="mt-1 mx-auto max-w-xs">Change business name and contact information.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/sharingandreviews')}">
          <img src="@/assets/images/misc/sharingandreviews.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Sharing and Reviews</h4>
          <p class="mt-1 mx-auto max-w-xs">Change profiles and select where to collect reviews/shares.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex" v-if="!$store.getters['dash/isCollaborator']">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/language')}">
          <img src="@/assets/images/misc/language.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Language</h4>
          <p class="mt-1 mx-auto max-w-xs">Change and customize language for your feedback survey.</p>
        </vx-card>
    </div>
    <div class="vx-col w-full lg:w-4/12 mb-base flex" v-if="!$store.getters['dash/isCollaborator']">
        <vx-card class="text-center cursor-pointer" @click="() => {$router.push('/dash/settings/lookandfeel')}">
          <img src="@/assets/images/misc/lookandfeel.png"  class="w-32 mx-auto"/>
          <h4 class="font-medium">Look and Feel</h4>
          <p class="mt-1 mx-auto max-w-xs">Change feedback link, logo and survey background color.</p>
        </vx-card>
    </div>
  </div>


*/


import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data() {
    return {}
  },
  components: {
    Pagesubtitle
  },
  created() {

  }
}
</script>

<style lang="scss">

</style>
